import styles from "./styles.module.css";
export default function Main({ children }) {
  const { main } = styles;
  return <main className={main}>{children}</main>;
}
